import React from 'react';
import { useTranslation } from 'react-i18next';
import { Button, Modal } from 'antd';

/**
 * Shown instead of launching a destination partner's restaurant while the
 * partner has neither a Stripe processing fee nor a recorded consent to a 0%
 * margin: the backend refuses that launch. Whoever sets the partner's rates is
 * offered the way there; anyone else is told the partner has to.
 */
export default function ProcessingFeeRateMissingModal({ open = false, onClose, onSetRate = undefined }) {
  const { t } = useTranslation(undefined, { keyPrefix: 'Modals:ProcessingFees:ProcessingFeeRateMissingModal' });

  return (
    <Modal
      open={open}
      onCancel={onClose}
      title={t('title')}
      footer={[
        <Button key="close" onClick={onClose} data-testid="processing-fee-missing-close">
          {t('buttons.close')}
        </Button>,
        onSetRate && (
          <Button key="set-rate" type="primary" onClick={onSetRate} data-testid="processing-fee-missing-set-rate">
            {t('buttons.set_rate')}
          </Button>
        ),
      ]}
    >
      <div data-testid="processing-fee-missing-modal">
        {onSetRate ? (
          <>
            <p>{t('description')}</p>
            <p className="mb-0">{t('partner_action')}</p>
          </>
        ) : (
          <p className="mb-0">{t('ask_partner')}</p>
        )}
      </div>
    </Modal>
  );
}
